// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2TKO7","left":"InfoRow_left__2TyGv"};